/**
 * Created by mukund on 7/17/15.
 */

'use strict';

angular.module('mediacloudApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('playbackAnalytics', {
                parent: 'site',
                url: '/administration/playback-analytics/:collectionId',
                params: {collectionId : null},
                data: {
                    roles: [],
                    pageTitle: 'playback-analytics.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/administration/playback_analytics/templates/playback-analytics.html',
                        controller: 'PlaybackAnalyticsController'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('playback-analytics');
                        return $translate.refresh();
                    }]
                }
            });
    });
